const Config = {
  // defaultPath: '/dashboard',
  defaultPath: '/home',
  basename: '/',
  layout: 'vertical',
  subLayout: '',
  collapseMenu: true,
  layoutType: 'menu-light',
  headerBackColor: 'header-blue',
  rtlLayout: false,
  navFixedLayout: true,
  headerFixedLayout: false,
  boxLayout: false,
};
export default Config;
